import type { DashboardFilter } from './DashboardFilter';

export const defaultDashboardFilter: DashboardFilter = {
  departments: [],
  tags: [],
  dateRange: null,
};
